import React from 'react';
import SideMenu from 'shared/components/ui/SideMenu';
import {
    Outlet
} from 'react-router-dom';
import {
    RouteErrorBoundary
} from 'shared/components/ErrorBoundary';

export default function SideMenuWrapper({
    section
}) {

    return (
        <div className='flex flex-grow h-full w-full !p-0'>
            <SideMenu section={section} />

            {/* Tier 2 — the side menu is the way out of a broken page, so it
                must outlive it. */}
            <RouteErrorBoundary name="side-menu-outlet">
                <Outlet />
            </RouteErrorBoundary>
        </div>
    );
}
